import Vue from 'vue'
import VueRouter from 'vue-router'
import baoliaoContent from '../views/baoliaoContent.vue'
import Gongyi from '../views/Gongyi.vue'
import CommunityContent from '../views/CommunityContent.vue'
import NewsContent from '../views/newsContent.vue'
import NewsContentT from '../views/newsContentT.vue'
import NewsContent2 from '../views/newsContent2.vue'
import Lianghui from '../views/Lianghui.vue'
import SpecialList from '../views/special-list.vue'
import ZhuanTiList from '../views/zhuanti-list.vue'
import appScrollList from '../views/appScrollList.vue'
import zwContent from '../views/zwContent.vue'
import zwTougao from '../views/zwTougao.vue'

import Custom_list from '../views/custom_list.vue';//定制专栏
import mjdpContent from '../views/mjdpContent.vue';//名家点评详情
import ftContent from '../views/ftContent.vue';//名师访谈列表


/*看视频的积分*/
import videojifenlist from '../views/video_jifen_list.vue';//
import login from '../views/login.vue';//
import video_jifen_content from '../views/video_jifen_content.vue';//


import videoProgram from '../views/videoProgram.vue';//
import uvideoProgram from '../views/uvideoProgram.vue';//
import videoProgramContent from '../views/videoProgramContent.vue';//
import uvideoContent from '../views/uvideoContent.vue';//视频号详情

import defaultVideoContent from '../views/defaultVideoContent.vue';//视频号详情
import previewLive from '../views/previewLive.vue';//直播预告
import readingList from '../views/readingList.vue';//必读

import chengshi from '../views/chengshi.vue';//成视


Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/Content&id=:id',
    name: 'Content',
    component: baoliaoContent
  },
  {
    path: '/Gongyi&id=:id',
    name: 'Gongyi',
    component: Gongyi
  },
  {
    path: '/CommunityContent&id=:id',
    name: 'CommunityContent',
    component: CommunityContent
  },
  {
    path: '/NewsContent&id=:id',
    name: 'NewsContent',
    component: NewsContent
  },{
    path: '/lianghui',
    name: 'lianghui',
    component: Lianghui
  },{
    //专栏
    path: '/SpecialList&id=:id',
    name: 'SpecialList',
    component: SpecialList
  },{
    //专题
    path: '/ZhuanTiList&id=:id',
    name: 'ZhuanTiList',
    component: ZhuanTiList
  },
  {
    //APP滚动广告
    path: '/appScrollList&id=:id',
    name: 'appScrollList',
    component: appScrollList
  },


  {
    path: '/NewsContent2&id=:id',
    name: 'NewsContent2',
    component: NewsContent2
  },{
    path: '/NewsContentT&id=:id',
    name: 'NewsContentT',
    component: NewsContentT
  },{
    path: '/zwContent&id=:id',
    name: 'zwContent',
    component: zwContent
  },{
    path: '/zwTougao',
    name: 'zwTougao',
    component: zwTougao
  },{
    path: '/custom_list&id=:id',
    name: 'custom_list',
    component: Custom_list
  },
  {
    path: '/mjdpContent&id=:id',
    name: 'mjdpContent',
    component: mjdpContent
  },{
    path: '/ftContent&id=:id',
    name: 'ftContent',
    component: ftContent
  },


  {
    path: '/videojifenlist',
    name: 'videojifenlist',
    component: videojifenlist
  },{
    path: '/video_jifen_content&id=:id',
    name: 'video_jifen_content',
    component: video_jifen_content
  },{
    path: '/login',
    name: 'login',
    component: login
  },


  {
    path: '/videoProgram',
    name: 'videoProgram',
    component: videoProgram
  }, {
    path: '/videoProgramContent&id=:id',
    name: 'videoProgramContent',
    component: videoProgramContent
  },




  {
    path: '/uvideoContent&id=:id',
    name: 'uvideoContent',
    component: uvideoContent
  },{
    path: '/uvideoProgram&id=:id',
    name: 'uvideoProgram',
    component: uvideoProgram
  },{
    path: '/defaultVideoContent&id=:id',
    name: 'defaultVideoContent',
    component: defaultVideoContent
  },
  {
    path: '/previewLive&id=:id',
    name: 'previewLive',
    component: previewLive
  },{
    path: '/readingList',
    name: 'readingList',
    component: readingList
  },{
    path: '/chengshi',
    name: 'chengshi',
    component: chengshi
  },







];

const router = new VueRouter({
  mode: 'hash',//history
  base: process.env.BASE_URL,
  routes
})

export default router
